declare const window: any

export const initChat = (delaySeconds: number = 0, partnerCode: string | undefined) => {
  if (partnerCode != 'www') {
    return
  }
  if (process.env.NODE_ENV === 'development') {
    return
  }
  window.setTimeout(() => {
    try {
      if (!window.embedded_svc) {
        // Add chat script if not exists
        const scriptElement = document.createElement('script')
        scriptElement.setAttribute('src', 'https://thebigredgroup.my.salesforce.com/embeddedservice/5.0/esw.min.js')
        scriptElement.onload = function () {
          initESW(null)
        }
        document.body.appendChild(scriptElement)
      } else {
        initESW('https://service.force.com')
      }
    } catch (error) {
      console.log('Error initialising live chat')
    }
  }, delaySeconds * 1000)
}

const initESW = (gslbBaseURL: string | null) => {
  window.embedded_svc.settings.smallCompanyLogoImgURL =
    'https://cdn.experienceoz.com.au/assets/imgproxy/catalogueType/2/miscGraph/151891.png?format=webp'
  window.embedded_svc.settings.displayHelpButton = true
  window.embedded_svc.settings.language = 'en'
  window.embedded_svc.settings.extraPrechatFormDetails = [
    {
      label: 'First Name',
      transcriptFields: ['PreChat_First_Name__c'],
    },
    {
      label: 'Last Name',
      transcriptFields: ['PreChat_Last_Name__c'],
    },
    {
      label: 'Email',
      transcriptFields: ['PreChat_Email__c'],
    },
    {
      label: 'ChatStartSite',
      value: 'ExOz-Storefront',
      transcriptFields: ['Chat_Start_Site__c'],
    },
    {
      label: 'Brand',
      value: 'Experience Oz',
      transcriptFields: ['Brand__c'],
    },
    {
      label: 'RecordTypeId',
      value: '0127F000000ElBlQAK',
    },
  ]

  window.embedded_svc.settings.extraPrechatInfo = [
    {
      entityFieldMaps: [
        {
          doCreate: true,
          doFind: false,
          fieldName: 'LastName',
          isExactMatch: false,
          label: 'Last Name',
        },
        {
          doCreate: true,
          doFind: false,
          fieldName: 'FirstName',
          isExactMatch: false,
          label: 'First Name',
        },
        {
          doCreate: true,
          doFind: true,
          fieldName: 'Email',
          isExactMatch: true,
          label: 'Email',
        },
        {
          doCreate: true,
          doFind: true,
          fieldName: 'RecordTypeId',
          isExactMatch: true,
          label: 'RecordTypeId',
        },
      ],
      entityName: 'Contact',
      saveToTranscript: 'Contact',
      showOnCreate: true,
    },
  ]

  window.embedded_svc.settings.enabledFeatures = ['LiveAgent']
  window.embedded_svc.settings.entryFeature = 'LiveAgent'
  window.embedded_svc.init(
    'https://thebigredgroup.my.salesforce.com',
    'https://bigredgroup.secure.force.com/EXOZ',
    gslbBaseURL,
    '00D7F000000xEno',
    'Experience_Oz_Site',
    {
      baseLiveAgentContentURL: 'https://c.la1-c1-hnd.salesforceliveagent.com/content',
      deploymentId: '5727F000000HGph',
      buttonId: '5737F000000HCpb',
      baseLiveAgentURL: 'https://d.la1-c1-hnd.salesforceliveagent.com/chat',
      eswLiveAgentDevName: 'EmbeddedServiceLiveAgent_Parent04I5D00000000AaUAI_17e56865f4e',
      isOfflineSupportEnabled: false,
    }
  )
}
